/*
 * @Author: ZS
 * @Date: 2020-06-05 15:30:42
 * @LastEditors: ZS
 * @LastEditTime: 2020-06-28 15:54:23
 * @Description: file content
 */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/Home'
import DepartmentHomepage from '@/components/views/DepartmentHomepage'
import User from '@/components/views/User'
import Search from '@/components/views/Search'
import MattersGuide from '@/components/views/MattersGuide'
import ByTheme from '@/components/views/ByTheme'
import UserGuidance from '@/components/views/UserGuidance'
// 意见反馈
import FeedBack from "@/components/yjfk/index.vue";
// 工作台
import WorkBench from "@/components/workbench/index.vue";
Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [{
    path: '/',
    name: 'home', //主页
    component: Home
  }, {
    path: '/depart',
    name: 'departmentHomepage', //b部门主页
    component: DepartmentHomepage
  }, {
    path: '/user',
    name: 'user', //个人中心
    component: User,
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录才能进入的
    },
  }, {
    path: '/search',
    name: 'search', //检索页
    component: Search
  }, {
    path: '/guide',
    name: 'guide', //单个事项引导
    component: MattersGuide
  }, {
    path: '/byTheme',
    name: 'byTheme', //单个事项引导
    component: ByTheme
  }, {
    path: '/userGuide',
    name: 'userGuide', //单个事项引导
    component: UserGuidance
  },
  {
    path: "/feedBack",
    name: "feedBack",
    component: FeedBack,
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/workbench",
    name: "workbench",
    component: WorkBench,
    meta: {
      requireAuth: true
    }
  }
  ]
})
//解决重复点击报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js